import {useEffect} from "react";
import { useExtraData} from "./DataContext.js";

const BestsellerBadge = ({productId, small}) => {
    
    let { bestsellersData } = useExtraData();

    const bestsellerArray = bestsellersData.filter(bs => bs.product == productId);
    const positions = bestsellerArray.map(bs => bs.rank).sort(function(a, b){return a-b});
    const bestseller = bestsellerArray.find(bs => bs.rank == positions[0]);

    if (!bestseller) {
        return null;
    }
    return (
        <p className={'bestSellersTitle carouselBadgeHeader productBadge'+(small ? ' searchBadge' : '')} title={'Highest position: #' + bestseller.rank + ' on ' + bestseller.startDate}>
            <i className='fas fa-chart-line'></i>{(!small ? <span><strong>Bestseller</strong></span> : "")}
        </p>
    )
}

export default BestsellerBadge;